"use strict";

exports.__esModule = true;
exports.AddIcon = void 0;

var _icon = require("@chakra-ui/icon");

var AddIcon = (0, _icon.createIcon)({
  d: "M0,12a1.5,1.5,0,0,0,1.5,1.5h8.75a.25.25,0,0,1,.25.25V22.5a1.5,1.5,0,0,0,3,0V13.75a.25.25,0,0,1,.25-.25H22.5a1.5,1.5,0,0,0,0-3H13.75a.25.25,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0v8.75a.25.25,0,0,1-.25.25H1.5A1.5,1.5,0,0,0,0,12Z",
  displayName: "AddIcon"
});
exports.AddIcon = AddIcon;
//# sourceMappingURL=Add.js.map